import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/components/layout/AppLayout.vue')

export const staticRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Root',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/deskoX1Video.html',
        redirect: '/deskoX1Video',
      },
      {
        path: '/index',
        name: 'Home',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: 'nav.home', breadcrumb: 'nav.home', keepAlive: true }
      },
      {
        path: '/goods/:id',
        name: 'ProductDetail',
        component: () => import('@/views/goods/GoodsInfo.vue'),
        meta: { title: 'product.detail', breadcrumb: 'product.detail' }
      },
      {
        path: '/download',
        name: 'Download',
        component: () => import('@/views/SoftwareView.vue'),
        meta: { title: 'nav.software', breadcrumb: 'nav.software' }
      },
      {
        path: '/solutions',
        name: 'Solutions',
        component: () => import('@/views/BaseView.vue'),
        meta: { title: 'nav.solutions', breadcrumb: 'nav.solutions' }
      },
      {
        path: '/support',
        name: 'Support',
        component: () => import('@/views/BaseView.vue'),
        meta: { title: 'nav.support', breadcrumb: 'nav.support' }
      },
      {
        path: '/deskoX1Video',
        name: 'DeskoX1Video',
        component: () => import('@/views/BaseView.vue'),
        meta: { title: 'nav.video', breadcrumb: 'nav.video' }
      },
      {
        path: '/contact',
        name: 'Contact',
        component: () => import('@/views/ContactView.vue'),
        meta: { title: 'nav.contact', breadcrumb: 'nav.contact' }
      },
      {
        path: '/products',
        name: 'Products',
        component: () => import('@/views/ProductView.vue'),
        meta: { title: 'nav.products', breadcrumb: 'nav.products' }
      }, {
        path: '/service',
        redirect: '/solutions',
      }, {
        path: '/providers',
        name: 'Providers',
        component: () => import('@/views/Providers.vue'),
        meta: { title: 'nav.providers', breadcrumb: 'nav.providers' }
      }
    ]
  },
  {
    path: '/uploader/:taskId',
    name: 'Uploader',
    component: () => import('@/views/UploaderView.vue'),
    meta: { title: 'nav.uploader', breadcrumb: 'nav.uploader' }
  },
  {
    path: '/portal/:type',
    name: 'Portal',
    component: () => import('@/views/ProtalView.vue'),
    meta: { title: 'nav.portal', breadcrumb: 'nav.portal' }
  }
]

export default staticRoutes
